import { AnimalDetailResponse } from "@app/shared/models/chip-details.model";
import { Content } from "pdfmake/interfaces";
import { checkboxSvg } from "./checkbox-canvas";
import { dateToGBFormatHelper } from "../date-to-GB-format.helper";
import { getBreedByTypeAndId } from "../breed.helper";

export function animalInformation(
    animal: AnimalDetailResponse,
    date: string,
): Content[] {
    return [
        {
            table: {
                widths: ['*'],
                body: [
                    [
                        {
                            alignment: 'left',
                            columns: [
                                {
                                    text: 'Kafsha',
                                    margin: [0, 3, 10, 0],
                                    width: 'auto',
                                    bold: true,
                                },
                                {
                                    text: 'Qen',
                                    alignment: 'right',
                                    margin: [45, 3, 10, 0],
                                    width: 'auto',
                                },
                                checkboxSvg(animal.type === 'dog', 12),
                                {
                                    text: 'Mace',
                                    alignment: 'right',
                                    margin: [45, 3, 10, 0],
                                    width: 'auto',
                                },
                                checkboxSvg(animal.type === 'cat', 12),
                                {
                                    text: 'Lepur / Fretkë',
                                    alignment: 'right',
                                    margin: [45, 3, 10, 0],
                                    width: 'auto',
                                },
                                checkboxSvg(animal.type === 'rabbitFerry', 12),
                            ],
                            border: [true, true, true, true],
                            margin: [0, 0, 30, 0],
                        },
                    ],
                ],
            },
            margin: [0, 10, 0, 10],
            layout: {
                defaultBorder: false,
            },
        },

        {
            table: {
                widths: [30, '*', '*', '*', '*', '*'],
                body: [
                    [
                        { text: 'Emri', bold: true },
                        {
                            text: animal.name.substring(0, 150),
                            border: [false, false, false, true],
                        },
                        '',
                        {
                            alignment: 'left',
                            columns: [
                                { text: 'Gjinia', bold: true, margin: [0, 3, 10, 0], width: 'auto' },
                                {
                                    text: 'Mashkull',
                                    alignment: 'right',
                                    margin: [25, 3, 5, 0],
                                    width: 'auto',
                                },
                                checkboxSvg(+animal.sex === 1, 12),
                                {
                                    text: 'Femër',
                                    alignment: 'right',
                                    margin: [25, 3, 5, 0],
                                    width: 'auto',
                                },
                                checkboxSvg(+animal.sex === 2, 12),
                            ],
                            border: [false, false, false, false],
                            colSpan: 2,
                        },
                        '',
                    ],
                    [
                        {
                            alignment: 'left',
                            columns: [
                                {
                                    text: 'Lloji i qimes',
                                    bold: true,
                                    margin: [0, 3, 10, 0],
                                    width: 'auto',
                                },
                                {
                                    text: 'Qime të gjata',
                                    alignment: 'right',
                                    margin: [25, 3, 5, 0],
                                    width: 'auto',
                                },
                                checkboxSvg(+animal.coatType === 1, 12),
                                {
                                    text: 'Qime të shkurtra',
                                    alignment: 'right',
                                    margin: [25, 3, 5, 0],
                                    width: 'auto',
                                },
                                checkboxSvg(+animal.coatType === 2, 12),
                                {
                                    text: 'Pa qime',
                                    alignment: 'right',
                                    margin: [25, 3, 5, 0],
                                    width: 'auto',
                                },
                                checkboxSvg(+animal.coatType === 3, 12),
                            ],
                            margin: [0, 10, 0, 0],
                            border: [false, false, false, false],
                            colSpan: 6,
                        },
                    ],
                ],
            },
            margin: [0, 10, 0, 10],
            layout: {
                defaultBorder: false,
            },
        },

        {
            table: {
                widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto'],
                body: [
                    [
                        { text: animal.type !== 'rabbitFerry' ? 'Raca' : '', bold: true },
                        {
                            text: getBreedByTypeAndId(animal.type, animal.breed),
                            border: [false, false, false, true],
                        },
                        { text: 'Data e lindjes', bold: true },
                        {
                            text: dateToGBFormatHelper(animal.dateOfBirth),
                            border: [false, false, false, true],
                        },
                        { text: 'Data e regjistrimit', bold: true },
                        {
                            text: dateToGBFormatHelper(date),
                            border: [false, false, false, true],
                        },
                    ],
                ],
            },
            margin: [0, 10, 0, 10],
            layout: {
                defaultBorder: false,
            },
        },
    ];
}
